<div class="text-card">
  <div class="header">
    @if (title) {
      <h1>{{ title }}</h1>
    }
    @if (editable) {
      <button mat-icon-button class="circle-button" (click)="onEditClick()">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>
  @if (!editMode) {
    <p>{{ text }}</p>
  }
  @if (editMode) {
    <form class="course-info-form" (ngSubmit)="onSave()">
      <div class="content-box">
        <textarea matInput [(ngModel)]="content" name="content" placeholder="Geben Sie hier den Text ein..."
        class="content-input"></textarea>
      </div>
      <div class="button-row">
        <button mat-stroked-button color="primary" type="button" (click)="onCancel()">
          Abbrechen
        </button>
        <button mat-flat-button color="primary" type="submit">
          Speichern
        </button>
      </div>
    </form>
  }
</div>